/**
 * Sistema di logging centralizzato per l'applicazione
 * 
 * In DEVELOPMENT: mostra tutti i log
 * In PRODUCTION: mostra solo errori critici
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Logger per informazioni di debug (solo in development)
 */
export const devLog = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

/**
 * Logger per informazioni generali (solo in development)
 */
export const devInfo = (...args) => {
  if (isDevelopment) {
    console.info(...args);
  }
};

/**
 * Logger per warning (sempre visibili)
 */
export const logWarn = (...args) => {
  console.warn(...args);
};

/**
 * Logger per errori (sempre visibili)
 */
export const logError = (...args) => {
  console.error(...args);
};

/**
 * Logger per eventi analytics/tracking (solo in development)
 */
export const devTrack = (eventName, data) => {
  if (isDevelopment) {
    console.log(`📊 Analytics Event: ${eventName}`, data);
  }
};

/**
 * Logger per Facebook Pixel (solo in development)
 */
export const devPixel = (eventName, data) => {
  if (isDevelopment) {
    console.log(`FB Pixel: ${eventName}`, data);
  }
};

/**
 * Logger per operazioni cache (solo in development)
 */
export const devCache = (...args) => {
  if (isDevelopment) {
    console.log('💾 Cache:', ...args);
  }
};

/**
 * Logger per operazioni Firestore (solo in development)
 */
export const devFirestore = (...args) => {
  if (isDevelopment) {
    console.log('🔥 Firestore:', ...args);
  }
};

/**
 * Logger per Remote Config (solo in development)
 */
export const devConfig = (...args) => {
  if (isDevelopment) {
    console.log('⚙️ Remote Config:', ...args);
  }
};

// Export default per compatibilità
const logger = {
  dev: devLog,
  info: devInfo,
  warn: logWarn,
  error: logError,
  track: devTrack,
  pixel: devPixel,
  cache: devCache,
  firestore: devFirestore,
  config: devConfig
};

export default logger;

